import { WHATSAPP_NUMBER } from '../data/site';

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

// Dispara o evento de conversão nas ferramentas que estiverem carregadas
// (PostHog já está no index.html; Meta Pixel e GA4 entram quando configurados).
export const trackLead = (source, props = {}) => {
  const payload = { source, ...props };
  try {
    window.posthog?.capture?.('whatsapp_click', payload);
    window.fbq?.('track', 'Contact', payload);
    window.gtag?.('event', 'generate_lead', payload);
  } catch (e) {
    // tracking nunca pode quebrar o clique
  }
};
